import { useState, useEffect, useContext, useRef } from "react";
import { selfhelpConfiguration } from "../../../api/automation/selfhelp_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import DialogBox from "../../../components/dialog/dialog.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Option, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, createTableColumn, TableCellLayout, Input, Textarea, Switch, Card, Image, Tooltip, Body1Stronger, Field, Link, Spinner } from "@fluentui/react-components";
import { SaveCopy20Regular, AddSquare20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, AddSquare20Filled, Delete20Regular, ReOrderDotsVertical16Regular, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, ArrowMaximize20Regular, DismissSquare24Filled, ChatMultipleHeart20Regular, BookTemplate20Regular, CalendarClock20Regular, SettingsCogMultiple20Regular, Wand20Regular, Info20Filled, Dismiss16Regular, CheckmarkLock20Regular, AlertBadge20Regular, BrainCircuit20Regular, Info16Filled, ImageAddRegular, ImageAdd24Regular } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { Inputs } from "../../../components/textarea/input.component";
import { Intent } from "../../../components/messagebar/messagebar.component";
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { GlobalContext } from "../../../hooks/globalContext";
import { MultipleSelectToString } from "../../../components/form-components/MultipleSelectToString";
import { MultiselectWithTags } from "../../../components/dropdown/multiselect.component";
import {
  DragDropContext,
  Draggable,
  DraggableProvided,
  DraggableRubric,
  DraggableStateSnapshot,
  DragStart,
  DragUpdate,
  Droppable,
  DroppableStateSnapshot,
  DropResult,
  resetServerContext,
  ResponderProvided,
  useKeyboardSensor,
  useMouseSensor,
  useTouchSensor,
} from "react-beautiful-dnd";
import { Dropdown } from "@fluentui/react-components";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { buttonContent, DynamicBoxingCSS, fullscreenIcon, SubSectionResponsive, inputsizestyle, lightTheme, messageTheme, overflowDivider, parentHome, primaryIcon, secondaryIcon, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import type { TextareaProps } from "@fluentui/react-components";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AutomationPages } from "../../../components/side_menu/InlineSidenav";
import { getStorageToken, uploadFile } from "../../../api/administration/upload";

const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

const iconStyleProps: any = {
  primaryFill: "#008099",
  className: "iconClass",
};

const initialState = {name: '',description: '',jsonData: ''}

const iconExitStyleProps: any = { primaryFill: "#d13438" };

export const Selfhelp = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  var dartNo: number = contextValue.dartNo;
  var nameValidationTimer = useRef(null);
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  const [activeTab, setActiveTab] = useState('Intro');
  const [dartSpecs, setDartSpecs]: any = useState([]);
  const [automationOverLayData, setAutomationOverLayData]: any = useState([]);
  const [jsonSchema, setJsonData]: any = useState({});
  const [uiSchema, setUiData]: any = useState({});
  const [initialDefaultValue,setInitialDefaultValue]: any = useState(initialState)
  const [formData, setFormData]: any = useState(initialState);
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [configFormData, setConfigFormData]: any = useState({
    clientEnabled: false,
    automation_name: '',
    description: '',
    category: '',
    category_description: '',
    sub_category: '',
    sub_category_description: '',
    os: '*',
    automation_sequence: '', 
    categoryIcon: '', 
    subCategoryIcon: ''
  });
  const [automationName, setAutomationName] = useState('');
  const [automationNameInEditForm, setAutomationNameInEditForm] = useState('');
  const [deleteAutomation, setDeleteAutomation]: any = useState(false);
  // const [isRefresh, setRefresh]: any = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [cloneForms, setCloneForms] = useState<any[]>([]);
  const [isToast, setIsToast] = useState(false);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [saveTriggered, setSaveTriggered]: any = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [inputBoxes, setInputBoxes] = useState<any>([{ id: '1', value: `Input Box 1` }]);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [automationSearchVal, setAutomationSearchVal] = useState("");
  const [automationSearchData, setAutomationSearchData] = useState([]);
  const [automationSearchDataObj, setAutomationSearchDataObj] = useState({});

  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState<any[]>([]);
  const [categorySearchVal, setCategorySearchVal] = useState("");
  const [categorySearchData, setCategorySearchData] = useState([]);
  const [categoryData, setCategoryData] = useState<any>({});
  const [disableCatInput, setDisableCatInput] = useState<any>(true);

  const [selectedSubCategoryOptions, setSelectedSubCategoryOptions] = useState<any[]>([]);
  const [subCategorySearchVal, setSubCategorySearchVal] = useState("");
  const [subCategorySearchData, setSubCategorySearchData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState<any>({});
  const [disableSubCatInput, setDisableSubCatInput] = useState<any>(true);

  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [classificationNameValidation, setClassificationNameValidation]: any = useState(true);
  const [selectedAutomation, setSelectedAutomation] = useState('');
  const [automationStatus, setAutomationStatus] = useState('not attached');
  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [searchType, setSearchType] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<String>('');
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
  const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);

  const [categoryFile, setCategoryFile] = useState<File | null>(null);
  const [categoryFilePreview, setCategoryFilePreview] = useState<string | null>(null);
  const [subCategoryFile, setSubCategoryFile] = useState<File | null>(null);
  const [subCategoryFilePreview, setSubCategoryFilePreview] = useState<string | null>(null);
  const [uploadStatus, setUploadStatus] = useState<string>("");
  const [categoryIssueLink, setCategoryIssueLink] = useState<string | null>(null);
  const [subCategoryIssueLink, setSubCategoryIssueLink] = useState<string | null>(null);

  const [token, setToken] = useState<any>("");
  console.log("categoryFile", categoryFile);
  console.log("subCategoryFile",subCategoryFile);

      useEffect(() => {
          const getToken = async () => {
              try {
                  const { token } = await getStorageToken();
                  console.log('token:', token);
                  setToken(token);
                  // await fetchTableData(token, pathName);
              } catch (error) {
                  console.error('Error fetching token:', error);
              }
          };
  
          getToken();
      }, []);



  useEffect(() => {
    setCreatedBy(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
  }, [uniqueCreatedBy, uniqueStatus]);

  //drag states
  const handleDragEnd = (result: any) => {
    // Check if the drag operation was successful
    if (!result.destination) {
      return;
    }
    console.log("result", result);

    // Reorder the input boxes based on the drag result
    const reorderedBoxes = Array.from(inputBoxes);
    const [movedBox] = reorderedBoxes.splice(result.source.index, 1);
    reorderedBoxes.splice(result.destination.index, 0, movedBox);
    console.log("result", result.destination.index);
    console.log("reorder", reorderedBoxes);
    console.log("inputbox on drag", inputBoxes);
    console.log("cloneform on deag", cloneForms);

    setCloneForms(reorderedBoxes);
    // Update the state with the reordered input boxes
    setInputBoxes(reorderedBoxes);
    let id: any;
    setCloneForms(cloneForms.filter((form) => form.id !== id));
  };

  // const handleNameInput: TextareaProps["onChange"] = (ev, data: any) => {
  //   var inputVal = data.value.trim();

  //   if(/^[a-zA-Z0-9]*$/.test(inputVal)){
  //     var flag = true;
  //     exportDetails.map((val: any) => { 
  //       if(val.classificationName == inputVal){
  //         flag = false;
  //       }
  //     });
  //     setClassificationNameValidation(flag);
  //     setClassificationName(inputVal);
  //   }
  // }

  var timer: any;
  const handleUserSearchInput = (e: any, type = '') => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const val = e.target.value;

      if (type === "category") {
        setCategorySearchVal(val);
      } else if (type === "subCategory") {
        setSubCategorySearchVal(val);
      } else if (type === "automation") {
        setAutomationSearchVal(val);
      }

      setSearchType(type);
    }, 700);
  }

  //clone logic
  interface FormItem {
    id: number;
    data: {};
  }

  const handleAddClone = (e: any) => {
    if (cloneForms.length < 10) {
      setCloneForms([...cloneForms, { id: Date.now(), data: {} }]);
    }
  };

  const handleRemoveClone = (id: any) => {
    setCloneForms(cloneForms.filter((form) => form.id !== id));
  };

  const handle = useFullScreenHandle();

  const handlenextbutton = () => {
    setActiveTab('Configure');
    console.log("clicked but not worked")
  }
  const buttonref: any = useRef(null);
  const handleOutsideButton = () => {
    buttonref?.current?.click();
  };
  const categoryFileRef   = useRef(null);
  const subCategoryFileRef  = useRef(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const file = event.target.files?.[0];
  
    if (file) {
      if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
        alert("Invalid file type! Please select a .png, .jpg, or .jpeg file.");
        return;
      }
  
      const fileURL = URL.createObjectURL(file); // Temporary URL for preview
      const newFileName = file.name;
  
      if (type === "Category") {
        const existingFileName = categoryFile?.name || configFormData.categoryIcon?.split("/").pop();
        
        if (existingFileName === newFileName) {
          alert("This image is already uploaded. Please select a different file.");
          return;
        }
  
        setCategoryFile(file);
        setCategoryFilePreview(fileURL);
      } else if (type === "Subcategory") {
        const existingFileName = subCategoryFile?.name || configFormData.subCategoryIcon?.split("/").pop();
  
        if (existingFileName === newFileName) {
          alert("This image is already uploaded. Please select a different file.");
          return;
        }
  
        setSubCategoryFile(file);
        setSubCategoryFilePreview(fileURL);
      }
  
      console.log(`Selected ${type} file:`, file);
    }
  };
  
  const handleSubmit = (e: any) => {
    e.preventDefault();
  }

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // if(value1 !== undefined && value1 !== '' && value2 !== undefined && value2 !== '') {
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
    // }
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
  }

  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  const handleNewAutoamtionClick = () => {
    setOverlayOpen(true);
    setOverlayName('addAutomation');
    setAutomationStatus('not attached');
    setFormData({ name: '', description: '', jsonData: '' });
    setConfigFormData({ clientEnabled: false, automation_name: '', description: '', category: '', category_description: '', sub_category: '', sub_category_description: '', os: '*', automation_sequence: '', categoryIcon: '', subCategoryIcon: '', categoryIssueLink: '', subCategoryIssueLink: ''});
    setSelectedCategoryOptions([]);
    setSelectedSubCategoryOptions([]);
    setSelectedOptions([]);
    setAutomationSearchVal('');
    setAutomationName('');
    setClassificationNameValidation(true);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9]*$/;
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      console.log("*****************************")
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1 === ("Name") || dropDownValue1 === ("Description") || dropDownValue1 === ("Status")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Created By")) {
    //   if(regexS.test(enteredValue)){
    //     setDropDownValue2(enteredValue);
    //     }
    // }
  }

  useEffect(() => {
    if (nameValidationTimer.current) {
      clearTimeout(nameValidationTimer.current);
    }

    nameValidationTimer.current = setTimeout(() => {
      formData.name.length > 0 && setAutomationName(formData.name);
      formData.name.length === 0 && setClassificationNameValidation(true);
    }, 700);
  }, [formData.name]);

  useEffect(() => {
    overlayName === 'editAutomation' && automationNameInEditForm === automationName && setClassificationNameValidation(true);
  }, [automationNameInEditForm, classificationNameValidation]);


  //data table column name code starts here
  // var columns = [
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong> Description </Body1Strong> },
  //   { key: "created_by", label: <Body1Strong> Created by </Body1Strong> },
  //   { key: "created_on", label: <Body1Strong> Created On (UTC) </Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong> Created On ({formattedTimeZone}) </Body1Strong> },
  //   { key: "last_modified", label: <Body1Strong> Last Modified (UTC) </Body1Strong> },
  //   { key: "last_modified_timezoned", label: <Body1Strong> Last Modified ({formattedTimeZone}) </Body1Strong> },
  //   { key: "status", label: <Body1Strong> Status </Body1Strong> },
  // ];
  //data table column name code ends here

  //data table present in the filter dropdown starts here
  // var columns1 = [
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1> Description </Caption1> },
  //   { key: "created_by", label: <Caption1> Created by </Caption1> },
  //   { key: "created_on", label: <Caption1> Created On </Caption1> },
  //   { key: "last_modified", label: <Caption1> Last Modified </Caption1> },
  //   { key: "status", label: <Caption1> Status </Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Automation?.Selfhelp.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "last_modified_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Automation?.Selfhelp.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Automation", page: "Selfhelp" });
  }, [contextValue.tableColumnsData]);

  useEffect(() => {
    // Direct, simple filtering
    const matchingData = final_data?.filter(
      item => 
        contextValue?.selectedRowIdInTable.includes(item.id) && 
        item.status !== "not attached"
    ) || [];
  
    // Set disable state based on matching data
    setDisableConfirmBtn(matchingData.length > 0);
  }, [contextValue?.selectedRowIdInTable]);

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        {permissions.includes("all") || permissions.includes("selfHelp_Fullaccess") ?

          <StackItem>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { handleNewAutoamtionClick(); }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading ?
                  <AddSquare20Regular {...secondaryIcon} />
                  : <AddSquare20Regular {...primaryIcon} />}</StackItem>
                <StackItem> <Caption1> Create Self-Service / Proactive </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Create Self-Service / Proactive </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }
        <StackItem>
          <Divider vertical />
        </StackItem>
        {/* <StackItem>
        <Button shape="circular" appearance="subtle" size="small">
          <Stack tokens={{childrenGap:5}} horizontal>
            <StackItem> <SaveCopy20Regular {...iconStyleProps}/> </StackItem>
            <StackItem> <Caption1> Duplicate </Caption1> </StackItem>
          </Stack>
        </Button>
      </StackItem>
      <StackItem>
        <Divider vertical/>
      </StackItem> */}
        <StackItem>
          <DialogBox
            headerButton={
              <>
                <Button shape="circular" appearance="transparent" size="small"
                  disabled={isdeletedisabled ? true : false} >
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>
                      {/* <Delete20Regular {...iconStyleProps} />  */}
                      {isdeletedisabled
                        ? (<Delete20Regular {...secondaryIcon} />)
                        : (<Delete20Regular {...primaryIcon} />)
                      }
                    </StackItem>
                    <StackItem> <Caption1> Delete </Caption1> </StackItem>
                  </Stack>
                </Button>
              </>
            }

            content={disableConfirmBtn ? "Enabled automation cannot be deleted. Please disable or unselect the enabled automation and try again." : "Please confirm if you want to proceed with deleting the automation."}

            footer=
            {
              <>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Button shape="circular" disabled={disableConfirmBtn} appearance="primary" onClick={() => { setDeleteAutomation(true); }} size="small">Confirm</Button>
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" size="small">Cancel</Button>
                  </StackItem>
                </Stack>
              </>
            }
          />
        </StackItem>
        <StackItem>
          <Divider vertical />
        </StackItem>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setIsRefresh(true); setCurrentPageNo(1); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {permissions.includes("all") || permissions.includes("selfHelp_Fullaccess") || permissions.includes("selfHelp_ReadandExport") ?
          <StackItem>
            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_selfh-help/proactive_automations.csv`}>
            </CSVLink>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true);/*userActivity('Export', `{"summary":"Self help automation list exported"}`);*/ }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> {loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </StackItem>
          :
          <StackItem>
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Export </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          </StackItem>
        }
        {/* <StackItem>
        <Button shape="circular" appearance="subtle" size="small">
          <Stack tokens={{childrenGap:5}} horizontal>
            <StackItem> <ArrowDownload20Regular {...iconStyleProps}/> </StackItem>
            <StackItem> <Caption1> Export </Caption1> </StackItem>
          </Stack>
        </Button>
      </StackItem> */}
        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  
  const editHandler = (val:any) => {
    setSpinnerLoad(true);
    setInitialDefaultValue({
      name:val?.automationName,
      description: val?.description,
    })
      setOverlayOpen(true); 
      setAutomationName(''); 
      setOverlayName('editAutomation'); 
      setRowID(val.id); 
      val.status.includes(`${contextValue.tenantName}:`) ? setAutomationStatus('attached') : setAutomationStatus('not attached'); 
      setSelectedAutomation(val.automationName); 
      setCategorySearchVal(""); 
      setAutomationSearchVal(""); 
      setSubCategorySearchVal(""); 
    }

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  var tempTableData: any = [];
  var menuLists: any = [];

  useEffect(() => {
    var tempExportData: any = [];
    var status = '';

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.status === 'not attached') {
        status = 'Not attached';
      } else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length === 0) {
          status = 'Enabled for other tenant';
        } else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus === 'all') {
            status = 'Enabled for All Devices';
          } else {
            status = curStatus?.split(",").length === 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      tempExportData.push({
        'Name': val.automationName,
        'Description': val.description,
        'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
        'Created On': convertToExcelFormat(val.createdOn),
        'Last Modified': val.lastModified ? convertToExcelFormat(val.lastModified) : "-",
        'Status': status,
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  // useEffect(() => {
  //   //roles and permissions
  //   async function loadRoute() {
  //     console.log("role:-",sessionStorage.getItem('role'))
  //     const role = sessionStorage.getItem('role');

  //     try {
  //       const [routeAllowed, permissions] = await shouldLoadRoute(role);

  //       if (routeAllowed) {
  //         console.log("permission===",permissions);

  //         setPermissions(permissions)
  //       } else {
  //         console.log('Route is not allowed.');
  //       }
  //     } catch (error) {
  //       console.error('Error loading route:', error);
  //     }
  //   }

  //   loadRoute();
  // }, []);
  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueCreatedBy: string[] = [];
      const newUniqueStatus: string[] = [];

      final_data?.forEach((val: any) => {
        if (val.createdBy && val.createdBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.createdBy)) {
          newUniqueCreatedBy.push(val.createdBy);
        }
        if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
          newUniqueStatus.push(val.status);
        }
      });

      setUniqueCreatedBy(newUniqueCreatedBy);
      setUniqueStatus(newUniqueStatus);
      console.log("Unique Created By:", newUniqueCreatedBy);
    } else {
      setUniqueCreatedBy([]);
      setUniqueStatus([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    var status = '';

    final_data !== undefined && final_data !== null
      ? final_data.map(async (val: any, i: any) => {
        const Name = val.automationName;
        if (val.status === 'not attached') {
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length === 0) {
            status = 'Enabled for other tenant';
          } else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus === 'all') {
              status = 'Enabled for All Devices';
            } else {
              status = curStatus?.split(",").length === 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }
        // const formattedAutomationName = Name.substring(0, 10) + "\n" + Name.substring(10, 23) + "\n" + Name.substring(23);

        {
          permissions.includes("all") || permissions.includes("selfHelp_Fullaccess") ?
            tempTableData.push({
              id: val.id,
              checkbox: "show" ,
              name: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => editHandler(val)}> {val.automationName} </Button> },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            })
            :
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              name: {
                label:
                  <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                    <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.automationName} </Button>
                  </Tooltip>
              },
              description: { label: <Caption1> {val.description} </Caption1>, status: "" },
              created_by: { label: <Caption1> {val.createdBy} </Caption1> },
              created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
              created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
              last_modified: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
              last_modified_timezoned: { label: <Caption1> {convertToLocalTimezone(val.lastModified, userTimeZone)} </Caption1> },
              status: { label: <Caption1> {status} </Caption1> },
            });
        }

      }) : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    // setTimeout(() => {
    //   final_data !== undefined && final_data !== null && setLoading(false);
    // }, 500);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setIsRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
        setRefreshToast(false);
        }, 3000);
    }
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    if (saveBtnClicked) {
      let uploadedCategoryFileUrl = "";
      let uploadedSubCategoryFileUrl = "";
      overlayName === 'editAutomation' && (uploadedCategoryFileUrl = configFormData.categoryIcon) && (uploadedSubCategoryFileUrl = configFormData.subCategoryIcon);
      setCategoryIssueLink(configFormData?.categoryIssueLink);
      setSubCategoryIssueLink(configFormData?.subCategoryIssueLink);

      const uploadPromises = [];
  
      // Upload Category File if selected
      if (categoryFile) {
        uploadPromises.push(
          uploadFile(categoryFile, "category-folder", token, (progress) => {
            // setUploadProgress(progress);
            setUploadStatus(progress === 100 ? "Upload complete!" : `Uploading... ${progress}%`);
          })
          .then((response) => {
            console.log("Category File Upload Response:", response);
            if (response?.link) {
              uploadedCategoryFileUrl = response.link;
            }
          })
          .catch((error) => {
            console.error("Category file upload failed:", error);
          })
        );
      }
  
      // Upload Sub-Category File if selected
      if (subCategoryFile) {
        uploadPromises.push(
          uploadFile(subCategoryFile, "subcategory-folder", token, (progress) => {
            // setUploadProgress(progress);
            setUploadStatus(progress === 100 ? "Upload complete!" : `Uploading... ${progress}%`);
          })
          .then((response) => {
            console.log("Subcategory File Upload Response:", response);
            if (response?.link) {
              uploadedSubCategoryFileUrl = response.link;
            }
          })
          .catch((error) => {
            console.error("Subcategory file upload failed:", error);
          })
        );
      }
  
      // Wait for all uploads to complete before saving form data
      Promise.allSettled(uploadPromises).then((results) => {
        results.forEach((result, index) => {
          if (result.status === "rejected") {
            console.error(`Upload failed for file #${index + 1}:`, result.reason);
          }
        });
  
        setFormData({
          ...formData,
          jsonData: {
            clientEnabled: configFormData.clientEnabled,
            automation_name: configFormData.automation_name,
            description: configFormData.description,
            category: selectedCategoryOptions.length > 0 ? selectedCategoryOptions[0].trim() : '',
            category_description: configFormData.category_description,
            sub_category: selectedSubCategoryOptions.length > 0 ? selectedSubCategoryOptions[0].trim() : '',
            sub_category_description: configFormData.sub_category_description,
            os: configFormData.os,
            automation_sequence: configFormData.automation_sequence,
            categoryIcon: uploadedCategoryFileUrl, // Store uploaded category file URL
            subCategoryIcon: uploadedSubCategoryFileUrl, // Store uploaded subcategory file URL
            // categoryIcon: configFormData.uploadedCategoryFileUrl, 
            // subCategoryIcon: configFormData.uploadedSubCategoryFileUrl,
            categoryIssueLink: categoryIssueLink,
            subCategoryIssueLink: subCategoryIssueLink,
          }
        });
  
        setSaveTriggered(true);
      });
  
    } else {
      setSaveTriggered(false);
      setFormData({ name: '', description: '', jsonData: '' });
      setCategorySearchVal("");
      setAutomationSearchVal("");
      setSubCategorySearchVal("");
      setOverlayName('');
      setAutomationName('');
    }
  }, [saveBtnClicked]);

  console.log("categoryIssueLink",categoryIssueLink)
  console.log("SubcategoryIssueLink",subCategoryIssueLink)
  
  

  useEffect(() => {
    console.log("CategoryOptions=", selectedCategoryOptions);
    console.log("Object.keys(categoryData)=", categoryData);

    if (selectedCategoryOptions?.length > 0 && Object.keys(categoryData).length === 0) {
      console.log("cat iff");

      setConfigFormData({ ...configFormData, category_description: '' });
    } else {
      console.log("cat else");
      setConfigFormData({ ...configFormData, category_description: categoryData[`${selectedCategoryOptions[0]}`]?.desc });
    }
  }, [selectedCategoryOptions]);

  useEffect(() => {
    console.log("selectedSubCategoryOptions=", selectedSubCategoryOptions);
    console.log("Object.keys(subCategoryData)=", subCategoryData);

    if (selectedSubCategoryOptions?.length > 0 && Object.keys(subCategoryData).length === 0) {
      console.log("new iff");

      setConfigFormData({ ...configFormData, sub_category_description: '' });
    } else {
      console.log("new else");
      setConfigFormData({ ...configFormData, sub_category_description: subCategoryData[`${selectedSubCategoryOptions[0]}`]?.desc });
    }
  }, [selectedSubCategoryOptions]);

  useEffect(() => {
    console.log("configFormData=", configFormData);
    console.log("categoryFile=", categoryFile);
    console.log("subCategoryFile=", subCategoryFile);
    console.log("FormData=", formData);
  }, [configFormData, formData,subCategoryFile,categoryFile]);

  console.log("categoryFilePreview",categoryFilePreview)
  console.log("categoryFilePreview",subCategoryFilePreview)
;
  useEffect(() => {

    if (dartSpecs?.length > 0) {
      var details = dartSpecs.length > 0 ? dartSpecs[0].details : "{}";
      details = JSON.parse(details);

      overlayName === 'addAutomation' && setAutomationOverLayData({
        headerTitle: "Create Self-Service / Proactive",
        size: "large",
        isTabs: true,
        tabItems: {
          Introduction: <form autoComplete="off" id="myFormSelfhelp" onSubmit={handleSubmit}> <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
            <StackItem>
              <p> <b>Name<Image src="/Dashboard/image/required.svg" /></b></p>
            </StackItem>
            <StackItem>
              <p>
                <Field
                  validationState={classificationNameValidation ? "none" : "warning"}
                  validationMessage={classificationNameValidation ? "" : "This automation name already exists"}>
                  <Inputs inputChange={setFormData} inputVal={formData} required={true} />
                </Field>
              </p>
              {/* {!classificationNameValidation && <Body1>This automation name already exists</Body1>} */}
            </StackItem>

            <StackItem>
              <Body1Stronger>What does this Selfhelp Do?</Body1Stronger>
            </StackItem>
            <StackItem>
              <p> <Resize inputChange={setFormData} inputValue={formData} /></p>
            </StackItem>
            <InfoBar title={"These are the basic details associated with this selfhelp."} />
            {Object.keys(details).map(key => (
              <>
                <StackItem>
                  <p><b>{key}</b></p>
                </StackItem>
                <StackItem>
                  <p>{details[key]}</p>
                </StackItem>
              </>
            ))}
          </Stack>
            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
          </form>,

          Configure: <form autoComplete="off" id="myFormSelfhelp" onSubmit={handleSubmit}>  <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>

            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" tokens={{ childrenGap: 20 }}>
              <StackItem >
                <Body1Strong>Should this automation be visible on the end user's device? </Body1Strong>
              </StackItem>
              <StackItem>
                <Switch onChange={(e: any) => { setConfigFormData({ ...configFormData, clientEnabled: e.target.checked }) }} checked={configFormData.clientEnabled ? true : false} label={configFormData.clientEnabled ? "Enabled" : "Disabled"} />
              </StackItem>
            </Stack>


            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Automation Name to be showcased on the client interface <Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Input value={configFormData.automation_name} onChange={(e: any) => { setConfigFormData({ ...configFormData, automation_name: e.target.value }) }} required style={inputsizestyle} />
            </Stack>

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Description for Automation to be showcased on the client interface<Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Textarea resize="both" value={configFormData.description} size="small" onChange={(e: any) => setConfigFormData({ ...configFormData, description: e.target.value })} required cols={39} />
            </Stack>

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Category<Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'category')} options={categorySearchData} setSelectedOptions=   {setSelectedCategoryOptions} selectedOptions={selectedCategoryOptions} multi={false} tag={true} placeholder="Please Search" required={selectedCategoryOptions.length > 0 ? false : true} />
                </StackItem>
                <StackItem>
                    <ImageAdd24Regular {...primaryIcon} onClick={() => categoryFileRef.current?.click()} style={{ cursor: "pointer" }} />
                    <input
                      ref={categoryFileRef}
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => handleFileSelect(e, "Category")}
                      style={{ display: "none" }}
                    />
                </StackItem>
                <StackItem>
                  {categoryFilePreview ? (
                    <img src={categoryFilePreview} alt="Category Preview" style={{ width: 50, height: 50, borderRadius: 8 }} />
                  ) : (
                    <Text>No file selected</Text>
                  )}
                </StackItem>

                {selectedCategoryOptions?.length > 0 && categoryData[`${selectedSubCategoryOptions[0]}`]?.types === 'proactive' && configFormData.clientEnabled ? <Text>Its proactive category</Text> : ''}
              </Stack>
            </Stack>
            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Category Description<Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Textarea disabled={disableCatInput ? true : false} resize="both" value={configFormData.category_description} size="small" onChange={(e: any) => setConfigFormData({ ...configFormData, category_description: e.target.value })} cols={39} />
              <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
              <Input
                type="text"
                value={categoryIssueLink}
                placeholder="Enter URL"
                onChange={(e) => setCategoryIssueLink(e.target.value)}
              />
              {categoryIssueLink && (
                <Link href={categoryIssueLink} target="_blank" /* rel="noopener noreferrer" */ >
                  Open Link
                </Link>
              )}
            </Stack>

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Sub-Category</Body1Strong>
              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'subCategory')} options={subCategorySearchData} setSelectedOptions={setSelectedSubCategoryOptions} selectedOptions={selectedSubCategoryOptions} multi={false} tag={true} placeholder="Please Search" />
                </StackItem>

                <StackItem>
                    <ImageAdd24Regular {...primaryIcon} onClick={() => subCategoryFileRef.current?.click()} style={{ cursor: "pointer" }} />
                    <input
                      ref={subCategoryFileRef}
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => handleFileSelect(e, "Subcategory")}
                      style={{ display: "none" }}
                    />
                </StackItem>
                <StackItem>
                {subCategoryFilePreview ? (
                  <img src={subCategoryFilePreview} alt="Category Preview" style={{ width: 50, height: 50, borderRadius: 8 }} />
                ) : (
                  <Text>No file selected</Text>
                )}
                </StackItem>
                {selectedSubCategoryOptions?.length > 0 && subCategoryData[`${selectedSubCategoryOptions[0]}`]?.types === 'proactive' && configFormData.clientEnabled ? <Text>Its proactive sub-category</Text> : ''}
              </Stack>
            </Stack>

            {/* add from */}
            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Sub-Category Description</Body1Strong>
              <Textarea disabled={disableSubCatInput} resize="both" value={configFormData.sub_category_description} size="small" onChange={(e: any) => setConfigFormData({ ...configFormData, sub_category_description: e.target.value })} cols={39} />
              <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
              <Input
                type="text"
                value={subCategoryIssueLink}
                placeholder="Enter URL"
                onChange={(e) => setSubCategoryIssueLink(e.target.value)}
                // required={true}
              />

              {/* Show Clickable Link if a valid URL is entered */}
              {subCategoryIssueLink && (
                <Link href={subCategoryIssueLink}  target="_blank" /* rel="noopener noreferrer" */>
                  Open Link
                </Link>
              )}
            </Stack>

            {overlayName !== 'addAutomation' &&
              <>
                <StackItem>
                  <Body1Strong>OS<Image src="/Dashboard/image/required.svg" /></Body1Strong>
                </StackItem>
              </>
            }

            {overlayName !== 'addAutomation' &&
              <>
                <StackItem>
                  <Dropdown placeholder="Select" defaultValue={configFormData.os == 7 ? 'Windows 7' : configFormData.os == 8 ? 'Windows 8' : configFormData.os == 10 ? 'Windows 10' : configFormData.os == 11 ? 'Windows 11' : "Common"} defaultSelectedOptions={[configFormData.os]} >
                    <Option value="7" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "7" })}>Windows 7</Option>
                    <Option value="8" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "8" })}>Windows 8</Option>
                    <Option value="10" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "10" })}>Windows 10</Option>
                    <Option value="11" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "11" })}>Windows 11</Option>
                    <Option value="*" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "*" })}>Common</Option>
                  </Dropdown>
                </StackItem>
              </>
            }

            <InfoBar title={"Choose the automations to incorporate into the SelfHelp solution. Please select them in the exact order of execution for a smooth operation, ensuring both efficiency and effectiveness."} />

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Automations<Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  {/* <Button shape="circular" appearance="subtle" aria-label="Close" icon={<ReOrderDotsVertical16Regular/>}/> */}
                </StackItem>
                <StackItem>
                  <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'automation')} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={true} tag={true} placeholder="Please Search" required={configFormData.automation_sequence != "" ? false : true} />
                </StackItem>
                <StackItem>
                  {/* <Button shape="circular" appearance="subtle" aria-label="Close" icon={<AddSquare20Filled/>} onClick={handleAddClone}></Button> */}
                </StackItem>
              </Stack>
            </Stack>
            <Stack tokens={{ childrenGap: 15 }}>
              {cloneForms.map((val: any) => (
                <Stack horizontal tokens={{ childrenGap: 5 }}>
                  <StackItem>
                    <MultiselectWithTags options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} />
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" appearance="subtle" aria-label="Close" icon={<Delete20Regular />} onClick={() => handleRemoveClone(val.id)}></Button>
                  </StackItem>
                </Stack>
              ))}
            </Stack>

            {/* drag and drop code for automation starts here*/}
            {/* <div className="container">
              <div className="card">
                <DragDropContext onDragEnd = {(result)=>handleDragEnd(result)}>
                  <Droppable droppableId="input-boxes" direction="vertical">
                    {(provided) => 
                    (
                      <div {...provided.droppableProps} ref={provided.innerRef} >
                        <Stack tokens={{childrenGap:10}}>
                          {inputBoxes.map((inputBox: any, index: any) => (   
                          <Draggable
                          key={inputBox.id} draggableId={inputBox.id} index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                              >
                                <Stack tokens={{childrenGap:10}} >
                                  <Stack key={inputBox.id}>
                                    <Stack horizontal tokens={{childrenGap:5}}>
                                      <StackItem>
                                        <Button shape="circular" appearance="subtle" aria-label="Close" icon={<ReOrderDotsVertical16Regular/>} {...provided.dragHandleProps}/>
                                      </StackItem>
                                      <StackItem>
                                        <MultiselectWithTags options={array} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} /> 
                                      </StackItem>
                                      <StackItem>
                                        {index === 0 ? <Button shape="circular"  appearance="subtle" aria-label="Close" icon={<AddSquare20Filled/>} onClick={handleAddClone}></Button> :  <Button shape="circular" appearance="subtle" aria-label="Close" icon={<Delete20Regular/>} onClick={()=>handleRemoveClone(inputBox.id)}/>}
                            
                                      </StackItem>
                                    </Stack>
                                  </Stack>
                                </Stack>
                              </div>
                            )}
                          </Draggable>
                          ))}
                          {provided.placeholder}
                        </Stack>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div> */}
            {/* drag and drop code for automation ends here*/}
          </Stack>
            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
          </form>,

          "Review Data":
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem>
                <Body1Strong>Name</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <Body1Strong>What does this Selfhelp Do?</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem>
                    <Body1Strong>Should this automation be visible on the end user's device?</Body1Strong>
                  </StackItem>

                  <StackItem>
                    <Switch disabled={true} checked={configFormData.clientEnabled ? true : false} label={configFormData.clientEnabled ? "Enabled" : "Disabled"} />
                  </StackItem>
                </Stack>
              </StackItem>

              <StackItem>
                <Body1Strong>Automation Name to be showcased on the client interface</Body1Strong>
              </StackItem>
              <StackItem>
                <Input disabled={true} value={configFormData.automation_name} style={inputsizestyle} />
              </StackItem>

              <StackItem>
                <Body1Strong>Description for Automation to be showcased on the client interface</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.description} size="small" cols={39} />
              </StackItem>

              {selectedCategoryOptions.length > 0 && <StackItem>
                <Body1Strong>Category</Body1Strong>
              </StackItem>}
              <Stack horizontal tokens={{childrenGap:5}}>

                {selectedCategoryOptions.length > 0 && <StackItem>
                  <Badge color="informative">{selectedCategoryOptions[0]}</Badge>
                </StackItem>}
                <StackItem>
                  {/* <div style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                    <ImageAdd24Regular aria-disabled {...primaryIcon} onClick={() => categoryFileRef.current?.click()} style={{ cursor: "pointer" }} /> 
                    <input
                      ref={categoryFileRef}
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => handleFileSelect(e, "Category")}
                      style={{ display: "none" }}
                      disabled
                    />
                  </div>          */}
                {categoryFilePreview ? (
                  <img src={categoryFilePreview} alt="Category Preview" style={{ width: 50, height: 50, borderRadius: 8 }} aria-disabled />
                ) : (
                  <Text>No file selected</Text>
                )}
                </StackItem>
              </Stack>

              {/* review form */}
              <StackItem>
                <Body1Strong>Category Description</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.category_description} size="small" cols={39} />
              </StackItem>
              <Stack tokens={{childrenGap:5}}>
                <StackItem>
                  <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
                </StackItem>
                <StackItem>
                  <Input
                    style={inputsizestyle}
                    type="text"
                    value={categoryIssueLink}
                    placeholder="Enter URL"
                    // onChange={(e) => setCategoryIssueLink(e.target.value)}
                    disabled
                  />
                </StackItem>
              </Stack>

              {selectedSubCategoryOptions.length > 0 && selectedSubCategoryOptions[0].length > 0 && <StackItem>
                <Body1Strong>Sub-Category</Body1Strong>
              </StackItem>}
                    
              
                <Stack horizontal tokens={{childrenGap:10}}>
              {selectedSubCategoryOptions.length > 0 && selectedSubCategoryOptions[0].length > 0 && <StackItem>
                <Badge color="informative">{selectedSubCategoryOptions[0]}</Badge>
              </StackItem>}
              {subCategoryFilePreview ? (
                <img src={subCategoryFilePreview} alt="Category Preview" style={{ width: 50, height: 50, borderRadius: 8 }} aria-disabled />
              ) : (
                <Text>No file selected</Text>
              )}
                </Stack>

              <StackItem>
                <Body1Strong>Sub-Category Description</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.sub_category_description} size="small" cols={39} />
              </StackItem>

              <Stack tokens={{childrenGap:5}}>
                <StackItem>
                  <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
                </StackItem>
                <StackItem>
                  <Input
                    style={inputsizestyle}
                    type="text"
                    value={subCategoryIssueLink}
                    placeholder="Enter URL"
                    // onChange={(e) => setCategoryIssueLink(e.target.value)}
                    disabled
                />
                </StackItem>
              </Stack>

              <StackItem>
                <Body1Strong>OS</Body1Strong>
              </StackItem>
              <StackItem>
                <Dropdown disabled={true} placeholder="Select" defaultValue={configFormData.os == 7 ? 'Windows 7' : configFormData.os == 8 ? 'Windows 8' : configFormData.os == 10 ? 'Windows 10' : configFormData.os == 11 ? 'Windows 11' : "Common"} defaultSelectedOptions={[configFormData.os]}>
                  <Option value="7">Windows 7</Option>
                  <Option value="8">Windows 8</Option>
                  <Option value="10">Windows 10</Option>
                  <Option value="11">Windows 11</Option>
                  <Option value="*">Common</Option>
                </Dropdown>
              </StackItem>

              <StackItem>
                <Body1Strong>Automations</Body1Strong>
              </StackItem>

              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  {/* <Button shape="circular" appearance="subtle" aria-label="Close" icon={<ReOrderDotsVertical16Regular/>}/> */}
                </StackItem>
                {/* <MultiselectWithTags disabled={true} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={true} tag={true} />  */}
                {selectedOptions?.map((val: any) => <StackItem><Badge color="informative">{val}</Badge></StackItem>)}
              </Stack>

              {/* <Stack tokens={{childrenGap: 15}}>
                {cloneForms.map((val: any) => (
                  <Stack horizontal tokens={{childrenGap:5}}>
                    <StackItem>
                      <MultiselectWithTags disabled={true} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} /> 
                    </StackItem>
                  </Stack>
                ))}
              </Stack> */}
            </Stack>
        },
      });

      overlayName === 'editAutomation' && automationStatus === 'not attached' && setAutomationOverLayData({
        headerTitle: `Editss ${selectedAutomation} Self-Service / Proactive`,
        size: "large",
        isTabs: true,
        tabItems: {
          Introduction: spinnerLoad ?
            <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
              <Spinner />
            </Stack> :
            <form autoComplete="off" id="myFormSelfhelp" onSubmit={handleSubmit}>
              <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                <StackItem>
                  <p> <b>Name<Image src="/Dashboard/image/required.svg" /></b></p>
                </StackItem>
                <StackItem>
                  <p>
                    <Field
                      validationState={classificationNameValidation ? "none" : "warning"}
                      validationMessage={classificationNameValidation ? "" : "This automation name already exists"}>
                      <Inputs inputChange={setFormData} inputVal={formData} required={true} />
                    </Field>
                  </p>
                  {/* {!classificationNameValidation && <Body1>This automation name already exists</Body1>} */}
                </StackItem>

                <StackItem>
                  <Body1Stronger>What does this Selfhelp Do?</Body1Stronger>
                </StackItem>
                <StackItem>
                  <p> <Resize inputChange={setFormData} inputValue={formData} /></p>
                </StackItem>
                <InfoBar title={"These are the basic details associated with this selfhelp."} />
                {Object.keys(details).map(key => (
                  <>
                    <StackItem>
                      <p><b>{key}</b></p>
                    </StackItem>
                    <StackItem>
                      <p>{details[key]}</p>
                    </StackItem>
                  </>
                ))}
              </Stack>
              <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
            </form>,

          Configure: <form autoComplete="off" id="myFormSelfhelp" onSubmit={handleSubmit}> <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
            <StackItem>
              <Stack horizontal tokens={{ childrenGap: 20 }}>
                <StackItem>
                  <Body1Strong>Should this automation be visible on the end user's device?</Body1Strong>
                </StackItem>

                <StackItem>
                  <Switch onChange={(e: any) => { setConfigFormData({ ...configFormData, clientEnabled: e.target.checked }) }} checked={configFormData.clientEnabled ? true : false} label={configFormData.clientEnabled ? "Enabled" : "Disabled"} />
                </StackItem>
              </Stack>
            </StackItem>

            <StackItem>
              <Body1Strong>Automation Name to be showcased on the client interface <Image src="/Dashboard/image/required.svg" /></Body1Strong>
            </StackItem>
            <StackItem>
              <Input value={configFormData.automation_name} onChange={(e: any) => { setConfigFormData({ ...configFormData, automation_name: e.target.value }) }} required style={inputsizestyle} />
            </StackItem>

            <StackItem>
              <Body1Strong>Description for Automation to be showcased on the client interface<Image src="/Dashboard/image/required.svg" /></Body1Strong>
            </StackItem>
            <StackItem>
              <Textarea resize="both" value={configFormData.description} size="small" onChange={(e: any) => setConfigFormData({ ...configFormData, description: e.target.value })} required cols={39} />
            </StackItem>

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Category<Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'category')} options={categorySearchData} setSelectedOptions={setSelectedCategoryOptions} selectedOptions={selectedCategoryOptions} multi={false} tag={true} placeholder="Please Search" required={selectedCategoryOptions.length > 0 ? false : true} />
                </StackItem>
                <StackItem>
                    <ImageAdd24Regular {...primaryIcon} onClick={() => categoryFileRef.current?.click()} style={{ cursor: "pointer" }} />
                    <input
                      ref={categoryFileRef}
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => handleFileSelect(e, "Category")}
                      style={{ display: "none" }}
                    />
                    <Image src={`${configFormData.categoryIcon}`} alt="category" height={20} width={20} />
                </StackItem>
                {selectedCategoryOptions?.length > 0 && categoryData[`${selectedSubCategoryOptions[0]}`]?.types === 'proactive' && configFormData.clientEnabled ? <Text>Need to change the text</Text> : ''}
              </Stack>
            </Stack>

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Category Description<Image src="/Dashboard/image/required.svg" /></Body1Strong>
              <Textarea resize="both" disabled={disableCatInput} value={configFormData.category_description} size="small" onChange={(e: any) => setConfigFormData({ ...configFormData, category_description: e.target.value })} cols={39} />
              <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
              <Input
                type="text"
                value={configFormData.categoryIssueLink || ""}
                placeholder="Enter URL"
                // onChange={(e) => setCategoryIssueLink(e.target.value)}
                onChange={(e) => {
                    setConfigFormData({ ...configFormData, categoryIssueLink: e.target.value })
                    setCategoryIssueLink(e.target.value)
                  }
                } 

              />
              {categoryIssueLink && (
                <Link href={categoryIssueLink} target="_blank" /* rel="noopener noreferrer" */ >
                  Open Link
                </Link>
              )}
            </Stack>

          

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Sub-Category</Body1Strong>
              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'subCategory')} options={subCategorySearchData} setSelectedOptions={setSelectedSubCategoryOptions} selectedOptions={selectedSubCategoryOptions} multi={false} tag={true} placeholder="Please Search" />
                </StackItem>

                <StackItem>
                    <ImageAdd24Regular {...primaryIcon} onClick={() => subCategoryFileRef.current?.click()} style={{ cursor: "pointer" }} />
                    <input
                      ref={subCategoryFileRef}
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => handleFileSelect(e, "Subcategory")}
                      style={{ display: "none" }}
                    />
                    <Image src={`${configFormData.subCategoryIcon}`} alt="subcategory" height={20} width={20}/>
                </StackItem>
                {selectedSubCategoryOptions?.length > 0 && subCategoryData[`${selectedSubCategoryOptions[0]}`]?.types === 'proactive' && configFormData.clientEnabled ? <Text>Need to change the text</Text> : ''}
              </Stack>
            </Stack>

            <Stack verticalFill tokens={{ childrenGap: 5 }}>
              <Body1Strong>Sub-Category Description</Body1Strong>
              <Textarea disabled={disableSubCatInput} resize="both" value={configFormData.sub_category_description} size="small" onChange={(e: any) => setConfigFormData({ ...configFormData, sub_category_description: e.target.value })} cols={39} />
              <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
              <Input
                type="text"
                value={configFormData.subCategoryIssueLink || ""}
                placeholder="Enter URL"
                onChange={(e) => {
                    setConfigFormData({ 
                    ...configFormData, 
                    subCategoryIssueLink: e.target.value 
                  })
                  setSubCategoryIssueLink(e.target.value);
                }
              }
              />

              {/* Show Clickable Link if a valid URL is entered */}
              {subCategoryIssueLink && (
                <Link href={subCategoryIssueLink}  target="_blank" /* rel="noopener noreferrer" */>
                  Open Link
                </Link>
              )}
            </Stack>

            <StackItem>
              <Body1Strong>OS<Image src="/Dashboard/image/required.svg" /></Body1Strong>
            </StackItem>

            <StackItem>
              <Dropdown placeholder="Select" defaultValue={configFormData.os == 7 ? 'Windows 7' : configFormData.os == 8 ? 'Windows 8' : configFormData.os == 10 ? 'Windows 10' : configFormData.os == 11 ? 'Windows 11' : "Common"} defaultSelectedOptions={[configFormData.os]} >
                <Option value="7" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "7" })}>Windows 7</Option>
                <Option value="8" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "8" })}>Windows 8</Option>
                <Option value="10" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "10" })}>Windows 10</Option>
                <Option value="11" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "11" })}>Windows 11</Option>
                <Option value="*" onClick={(e: any) => setConfigFormData({ ...configFormData, os: "*" })}>Common</Option>
              </Dropdown>
            </StackItem>

            <StackItem>
              <InfoBar title={"Choose the automations to incorporate into the SelfHelp solution. Please select them in the exact order of execution for a smooth operation, ensuring both efficiency and effectiveness"} />
            </StackItem>

            <StackItem>
              <Body1Strong>Automations<Image src="/Dashboard/image/required.svg" /></Body1Strong>
            </StackItem>

            <Stack horizontal tokens={{ childrenGap: 5 }}>
              <StackItem>
                {/* <Button shape="circular" appearance="subtle" aria-label="Close" icon={<ReOrderDotsVertical16Regular/>}/> */}
              </StackItem>
              <StackItem>
                <MultiselectWithTags onChange={(e: any) => handleUserSearchInput(e, 'automation')} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={true} tag={true} placeholder="Please Search" required={configFormData.automation_sequence != "" ? false : true} />
              </StackItem>
              <StackItem>
                {/* <Button shape="circular" appearance="subtle" aria-label="Close" icon={<AddSquare20Filled/>} onClick={handleAddClone}></Button> */}
              </StackItem>
            </Stack>

            <Stack tokens={{ childrenGap: 15 }}>
              {cloneForms.map((val: any) => (
                <Stack horizontal tokens={{ childrenGap: 5 }}>
                  <StackItem>
                    <MultiselectWithTags options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} />
                  </StackItem>
                  <StackItem>
                    <Button shape="circular" appearance="subtle" aria-label="Close" icon={<Delete20Regular />} onClick={() => handleRemoveClone(val.id)}></Button>
                  </StackItem>
                </Stack>
              ))}
            </Stack>

            {/* drag and drop code for automation starts here*/}
            {/* <div className="container">
            <div className="card">
              <DragDropContext onDragEnd = {(result)=>handleDragEnd(result)}>
                <Droppable droppableId="input-boxes" direction="vertical">
                  {(provided) => 
                  (
                    <div {...provided.droppableProps} ref={provided.innerRef} >
                      <Stack tokens={{childrenGap:10}}>
                        {inputBoxes.map((inputBox: any, index: any) => (   
                        <Draggable
                        key={inputBox.id} draggableId={inputBox.id} index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                            >
                              <Stack tokens={{childrenGap:10}} >
                                <Stack key={inputBox.id}>
                                  <Stack horizontal tokens={{childrenGap:5}}>
                                    <StackItem>
                                      <Button shape="circular" appearance="subtle" aria-label="Close" icon={<ReOrderDotsVertical16Regular/>} {...provided.dragHandleProps}/>
                                    </StackItem>
                                    <StackItem>
                                      <MultiselectWithTags options={array} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} /> 
                                    </StackItem>
                                    <StackItem>
                                      {index === 0 ? <Button shape="circular"  appearance="subtle" aria-label="Close" icon={<AddSquare20Filled/>} onClick={handleAddClone}></Button> :  <Button shape="circular" appearance="subtle" aria-label="Close" icon={<Delete20Regular/>} onClick={()=>handleRemoveClone(inputBox.id)}/>}
                          
                                    </StackItem>
                                  </Stack>
                                </Stack>
                              </Stack>
                            </div>
                          )}
                        </Draggable>
                        ))}
                        {provided.placeholder}
                      </Stack>
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div> */}
            {/* drag and drop code for automation ends here*/}
          </Stack>
            <Button shape="circular" ref={buttonref} type="submit" style={{ display: "none" }}>Validate</Button>
          </form>,

          "Review Data":
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <StackItem>
                <Body1Strong>Name</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <Body1Strong>What does this Selfhelp Do?</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem>
                    <Body1Strong>Should this automation be visible on the end user's device?</Body1Strong>
                  </StackItem>

                  <StackItem>
                    <Switch disabled={true} checked={configFormData.clientEnabled ? true : false} label={configFormData.clientEnabled ? "Enabled" : "Disabled"} />
                  </StackItem>
                </Stack>
              </StackItem>

              <StackItem>
                <Body1Strong>Automation Name to be showcased on the client interface</Body1Strong>
              </StackItem>
              <StackItem>
                <Input disabled={true} value={configFormData.automation_name} style={inputsizestyle} />
              </StackItem>

              <StackItem>
                <Body1Strong>Description for Automation to be showcased on the client interface</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.description} size="small" cols={39} />
              </StackItem>

              {selectedCategoryOptions.length > 0 && <StackItem>
                <Body1Strong>Category</Body1Strong>
              </StackItem>}
              {selectedCategoryOptions.length > 0 && <StackItem>
                <Badge color="informative">{selectedCategoryOptions[0]}</Badge>
              </StackItem>}

              {/* edit reviwe form */}
              <StackItem>
                <Body1Strong>Category Description</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.category_description} size="small" cols={39} />
              </StackItem>

              <Stack tokens={{childrenGap:5}}>
                <StackItem>
                  <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
                </StackItem>
                <StackItem>
                  <Input
                    style={inputsizestyle}
                    type="text"
                    value={configFormData.categoryIssueLink || ''}
                    disabled
                  />
                </StackItem>
              </Stack>

              {selectedSubCategoryOptions.length > 0 && selectedSubCategoryOptions[0].length > 0 && <StackItem>
                <Body1Strong>Sub-Category</Body1Strong>
              </StackItem>}

              {selectedSubCategoryOptions.length > 0 && selectedSubCategoryOptions[0].length > 0 && <StackItem>
                <Badge color="informative">{selectedSubCategoryOptions[0]}</Badge>
              </StackItem>}

              <StackItem>
                <Body1Strong>Sub-Category Description</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.sub_category_description} size="small" cols={39} />
              </StackItem>

              <Stack tokens={{childrenGap:5}}>
                <StackItem>
                  <Body1Strong>Enter the 'still facing issue?' to be displayed on the client:</Body1Strong>
                </StackItem>
                <StackItem>
                  <Input
                    style={inputsizestyle}
                    type="text"
                    value={configFormData.subCategoryIssueLink || ""}
                    disabled
                  />
                </StackItem>
              </Stack>

              <StackItem>
                <Body1Strong>OS</Body1Strong>
              </StackItem>
              <StackItem>
                <Dropdown disabled={true} placeholder="Select" defaultValue={configFormData.os == 7 ? 'Windows 7' : configFormData.os == 8 ? 'Windows 8' : configFormData.os == 10 ? 'Windows 10' : configFormData.os == 11 ? 'Windows 11' : "Common"} defaultSelectedOptions={[configFormData.os]}>
                  <Option value="7">Windows 7</Option>
                  <Option value="8">Windows 8</Option>
                  <Option value="10">Windows 10</Option>
                  <Option value="11">Windows 11</Option>
                  <Option value="*">Common</Option>
                </Dropdown>
              </StackItem>

              <StackItem>
                <Body1Strong>Automations</Body1Strong>
              </StackItem>

              <Stack horizontal tokens={{ childrenGap: 5 }}>
                <StackItem>
                  {/* <Button shape="circular" appearance="subtle" aria-label="Close" icon={<ReOrderDotsVertical16Regular/>}/> */}
                </StackItem>
                {/* <MultiselectWithTags disabled={true} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={true} tag={true} />  */}
                {selectedOptions?.map((val: any) => <StackItem><Badge color="informative">{val}</Badge></StackItem>)}
              </Stack>

              {/* <Stack tokens={{childrenGap: 15}}>
              {cloneForms.map((val: any) => (
                <Stack horizontal tokens={{childrenGap:5}}>
                  <StackItem>
                    <MultiselectWithTags disabled={true} options={automationSearchData} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} multi={false} tag={false} /> 
                  </StackItem>
                </Stack>
              ))}
            </Stack> */}
            </Stack>
        },
      });

      overlayName === 'editAutomation' && automationStatus !== 'not attached' && setAutomationOverLayData({
        headerTitle: `${selectedAutomation}`,
        size: "large",
        isTabs: true,
        tabItems: {
          Configuration:spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>:
            <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
              <InfoBar showSpaces={false} title={"Editing is disabled for this automation as it is associated with a Tenant or Device Classification. To make changes, please detach it first."} />
              <StackItem>
                <p> <b>Name</b></p>
              </StackItem>
              <StackItem>
                <p> <Inputs inputChange={setFormData} inputVal={formData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <Body1Strong>What does this Selfhelp Do?</Body1Strong>
              </StackItem>
              <StackItem>
                <p> <Resize inputChange={setFormData} inputValue={formData} disabled={true} /></p>
              </StackItem>

              <StackItem>
                <Stack horizontal tokens={{ childrenGap: 20 }}>
                  <StackItem>
                    <Body1Strong>Should this automation be visible on the end user's device?</Body1Strong>
                  </StackItem>

                  <StackItem>
                    <Switch disabled={true} checked={configFormData.clientEnabled ? true : false} label={configFormData.clientEnabled ? "Enabled" : "Disabled"} />
                  </StackItem>
                </Stack>
              </StackItem>

              <StackItem>
                <Body1Strong>Automation Name to be showcased on the client interface</Body1Strong>
              </StackItem>
              <StackItem>
                <Input disabled={true} value={configFormData.automation_name} />
              </StackItem>

              <StackItem>
                <Body1Strong>Description for Automation to be showcased on the client interface</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.description} size="small" />
              </StackItem>

              {selectedCategoryOptions.length > 0 && <StackItem>
                <Body1Strong>Category</Body1Strong>
              </StackItem>}
              {selectedCategoryOptions.length > 0 && <StackItem>
                <Badge color="informative">{selectedCategoryOptions[0]}</Badge>
              </StackItem>}

              <StackItem>
                <Body1Strong>Category Description</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.category_description} size="small" />
              </StackItem>

              {selectedSubCategoryOptions.length > 0 && selectedSubCategoryOptions[0].length > 0 && <StackItem>
                <Body1Strong>Sub-Category</Body1Strong>
              </StackItem>}

              {selectedSubCategoryOptions.length > 0 && selectedSubCategoryOptions[0].length > 0 && <StackItem>
                <Badge color="informative">{selectedSubCategoryOptions[0]}</Badge>
              </StackItem>}

              <StackItem>
                <Body1Strong>Sub-Category Description</Body1Strong>
              </StackItem>
              <StackItem>
                <Textarea disabled={true} resize="both" value={configFormData.sub_category_description} size="small" />
              </StackItem>

              <StackItem>
                <Body1Strong>OS</Body1Strong>
              </StackItem>
              <StackItem>
                <Dropdown disabled={true} placeholder="Select" defaultValue={configFormData.os == 7 ? 'Windows 7' : configFormData.os == 8 ? 'Windows 8' : configFormData.os == 10 ? 'Windows 10' : configFormData.os == 11 ? 'Windows 11' : "Common"} defaultSelectedOptions={[configFormData.os]}>
                  <Option value="7">Windows 7</Option>
                  <Option value="8">Windows 8</Option>
                  <Option value="10">Windows 10</Option>
                  <Option value="11">Windows 11</Option>
                  <Option value="*">Common</Option>
                </Dropdown>
              </StackItem>

              <StackItem>
                <Body1Strong>Automations</Body1Strong>
              </StackItem>

              <Stack horizontal tokens={{ childrenGap: 5 }}>
                {selectedOptions?.map((val: any) => <StackItem><Badge color="informative">{val}</Badge></StackItem>)}
              </Stack>
            </Stack>
        },
      });
    }
  }, [dartSpecs, overlayName, cloneForms, formData, configFormData, automationSearchData, categorySearchData, subCategorySearchData, disableCatInput, disableSubCatInput, classificationNameValidation,categoryFilePreview, categoryFile, subCategoryFile, categoryIssueLink, subCategoryIssueLink ]);

  useEffect(() => {
    if (!overlayOpen) {
      console.log("Clear the overlay data when overlay will get close");
      setCategoryFile(null);
      setSubCategoryFile(null);
      // Clear the form data
      setFormData({ name: '', description: '', jsonData: '' });

      // Clear the config form data
      setConfigFormData({
        clientEnabled: false,
        automation_name: '',
        description: '',
        category: '',
        category_description: '',
        sub_category: '',
        sub_category_description: '',
        os: '*',
        automation_sequence: '', 
        categoryIcon: '', 
        subCategoryIcon: '', 
        categoryIssueLink: '', 
        subCategoryIssueLink: '',
      });

      // Clear the overlay name after clearing the forms
      setTimeout(() => {
        setOverlayName('');
      }, 2000);
    }

    if (selectedOptions.length > 0) {
      var sequenceIdsArr: any = [];

      Object.keys(automationSearchDataObj).length > 0 && selectedOptions.map((val) => {
        if (!(sequenceIdsArr.includes(automationSearchDataObj[`${val}`]))) {
          sequenceIdsArr.push(automationSearchDataObj[`${val}`]);
        }
      });

      setConfigFormData({ ...configFormData, automation_sequence: sequenceIdsArr.join(",") });
    } else {
      setConfigFormData({ ...configFormData, automation_sequence: "" })
    }
  }, [overlayOpen, selectedOptions]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      tenant: tenantName,
      dartNo: dartNo,
      data: final_data,
      func: set_final_data,
      searchVal: searchVal,
      pageNo: pageNo,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
			setCurrentPageNo: setCurrentPageNo,
      isFilter: isfilter,
      setIsFilter: setIsFilter,
      dropDownValue1: dropDownValue1,
      dropdownValue2: dropDownValue2,
      setDartSpecs: setDartSpecs,
      setJsonData: setJsonData,
      setUiData: setUiData,
      deleteAutomation: deleteAutomation,
      setDeleteAutomation: setDeleteAutomation,
      setDeleteDisabled: setDeleteDisabled,
      isRefresh: isRefresh,
      setIsRefresh: setIsRefresh,
      filterArray: filterArray,
      setIsToast: setIsToast,
      setExportDetails: setExportDetails,
      overlayName: overlayName,
      setErrorToast: setErrorToast,
      setToastMessage: setToastMessage,
      setOverlayOpen: setOverlayOpen,
      setSaveBtnClicked: setSaveBtnClicked,
      setSaveTriggered: setSaveTriggered,
      jsonSchema: jsonSchema,
      rowID: rowID,
      automationSearchVal: automationSearchVal,
      saveBtnClicked: saveTriggered,
      categorySearchVal: categorySearchVal,
      subCategorySearchVal: subCategorySearchVal,
      setAutomationSearchDataObj: setAutomationSearchDataObj,
      automationSearchDataObj: automationSearchDataObj,
      setConfigFormData: setConfigFormData,
      setFormData: setFormData,
      setSelectedCategoryOptions: setSelectedCategoryOptions,
      setSelectedSubCategoryOptions: setSelectedSubCategoryOptions,
      setSelectedOptions: setSelectedOptions,
      setCategorySearchData: setCategorySearchData,
      setCategoryData: setCategoryData,
      setDisableCatInput: setDisableCatInput,
      setSubCategorySearchData: setSubCategorySearchData,
      setSubCategoryData: setSubCategoryData,
      setDisableSubCatInput: setDisableSubCatInput,
      setAutomationSearchData: setAutomationSearchData,
      formData: formData,
      setOverlayName: setOverlayName,
      newData: formData,
      selectedCategoryOptions: selectedCategoryOptions,
      exportBtnClicked: exportBtnClicked,
      setExportBtnClicked: setExportBtnClicked,
      dartSpecs: dartSpecs,
      setRefreshToast: setRefreshToast,
      setLoading: setLoading,
      automationName: automationName,
      setClassificationNameValidation: setClassificationNameValidation,
      setAutomationName: setAutomationName,
      setAutomationNameInEditForm: setAutomationNameInEditForm,
      loading: loading,
      searchType: searchType,
      initialDefaultValue: initialDefaultValue,
      setSpinnerLoad: setSpinnerLoad
    }
    if (currentPageNo || (!saveBtnClicked && overlayName === '') || (!saveBtnClicked && overlayName === 'editAutomation') || automationSearchVal.length > 0 || categorySearchVal.length > 0 || subCategorySearchVal.length > 0 || (saveTriggered && overlayName !== '') || (!saveBtnClicked && automationName.length > 0 && overlayName.length > 0) ) {
      selfhelpConfiguration(props);
    }
  }, [deleteAutomation, isRefresh, searchVal, saveTriggered, overlayName, rowID, currentPageNo, automationSearchVal, categorySearchVal, subCategorySearchVal, /*formData,*/ dartNo, isfilter, filterArray, exportBtnClicked, automationName]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
											{ name: "Automate", link: "/home" },
                      { name: "Automation", link: "/automate/automation/all_automations" },
                      { name: "Self-Service  / Proactive", link: "#" }
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal >
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomationPages("Self-Service / Proactive")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Last Modified') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}
                                      {(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Status") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                      {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 && (
                                <Stack horizontal wrap>
                                  {filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                </Stack>
                              )}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Self-Service is a solution available on the Nanoheal client for end-users and can be executed from the portal. Proactive solutions are visible only on the portal. Users can choose between Self-help and Proactive solutions during creation. By combining the automations developed in the previous section, comprehensive Self-help and Proactive solutions can be created."} />

                      </StackItem>

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (
                        <DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen}></DataTable>
                      ) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={automationOverLayData}
              saveBtnFunc={setSaveBtnClicked}
              saveBtnClicked={saveBtnClicked}
              isNavBtn={automationStatus !== 'not attached' ? false : true}
              handleOutsideButton={handleOutsideButton}
              handleSubmit={handleSubmit}
              classificationNameValidation={classificationNameValidation}
            />

            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveTriggered && overlayName === '') ? "Automation Deleted Successfully" : overlayName === 'addAutomation' ? "New Automation Created Successfully" : "Automation Edited Successfully"} footer="" />}

            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}
            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};